angular.module("warsApp.directives").directive('confirmationModal', ['$modal', function ($modal) {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            heading: '@',
            message: '@',
            open: '=',
            yesClick: '&',
            noClick: '&',
            size: '@'
        },
        link: function (scope, element, attrs) {

            var setDefaults = function () {
                if (!scope.title) { scope.title = "Confirm Action"; }
                if (!scope.message) { scope.message = "Are you sure?"; }
                if (!scope.size) { scope.size = "sm"; }
            };

            var openModal = function () {

                var modalInstance = $modal.open({
                    templateUrl: './app/views/modals/confirmationModal.html',
                    controller: 'confirmationModalController',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        title: function () {
                            return scope.title;
                        },
                        message: function () {
                            return scope.message;
                        },
                        heading: function() {
                            return scope.heading;
                        }
                    }
                });

                modalInstance.result.then(
                    function () {
                        scope.open = false;
                        if (scope.yesClick) {
                            scope.yesClick();
                        }
                    },
                    function () {
                        scope.open = false;
                        if (scope.noClick) {
                            scope.noClick();
                        }
                    }
                );
            };

            setDefaults();

            scope.$watch("open", function (newValue) {
                if (newValue) {
                    openModal();
                }
            });
        }
    };
}]);